// Криейтър: покани — одобрен криейтър генерира еднократни кодове с
// ограничена валидност и ги споделя. Записва се кой кого е поканил.

import React, { useCallback, useState } from 'react';
import { Text, View } from 'react-native';
import * as Clipboard from 'expo-clipboard';
import { useFocusEffect } from '@react-navigation/native';
import { api, API_URL } from '../../api';
import { showError, showSuccess } from '../../toast';
import { Badge, Button, Card, COLORS, Muted, Screen, Title } from '../../ui';
import { t } from '../../i18n';

// Линк за регистрация — отваря публичната страница на API домейна
const inviteLink = (code: string) => `${API_URL}/invite/${code}`;

export default function CreatorInvitesScreen() {
  const [invites, setInvites] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    api('/creator/invites').then((r) => setInvites(r.invites)).catch((e) => showError(e.message));
  }, []);
  useFocusEffect(load);

  const create = async () => {
    setLoading(true);
    try {
      const r = await api('/creator/invites', { body: {} });
      await Clipboard.setStringAsync(inviteLink(r.invite.code));
      showSuccess(t('Линкът за покана е създаден и копиран — изпратете го.'));
      load();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Покани')}</Title>
      <Card>
        <Muted>
          {t('Поканете друг криейтър: генерирайте линк и му го изпратете. Той се регистрира директно от линка в браузъра си, после влиза в приложението с телефон и парола. Линкът е еднократен и с ограничена валидност.')}
        </Muted>
        <Button title={t('+ Нов линк за покана (копира се)')} onPress={create} loading={loading} />
      </Card>

      {invites.map((inv) => {
        const maxUses = inv.maxUses ?? 1;
        const usedCount = inv.usedCount ?? (inv.usedBy ? 1 : 0);
        const exhausted = usedCount >= maxUses;
        const expired = !exhausted && new Date(inv.expiresAt) < new Date();
        return (
          <Card key={inv.id}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
              <Text style={{ fontSize: 12, color: COLORS.text, flex: 1 }} numberOfLines={1}>{inviteLink(inv.code)}</Text>
              {maxUses > 1 ? (
                <Badge text={t('{used}/{max} използвани', { used: usedCount, max: maxUses })} color={exhausted ? COLORS.success : undefined} />
              ) : inv.usedBy ? (
                <Badge text={`${inv.usedBy.firstName} ${inv.usedBy.lastName}`} color={COLORS.success} />
              ) : expired ? (
                <Badge text={t('Изтекла')} color={COLORS.muted} />
              ) : (
                <Badge text={t('Активна')} />
              )}
            </View>
            {!exhausted && !expired && (
              <Button
                title={t('Копирай линка')}
                variant="secondary"
                onPress={async () => {
                  await Clipboard.setStringAsync(inviteLink(inv.code));
                  showSuccess(t('Копирано.'));
                }}
              />
            )}
          </Card>
        );
      })}
      {invites.length === 0 && <Card><Muted>{t('Още нямате покани.')}</Muted></Card>}
    </Screen>
  );
}
